import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';
import { IotSources, UpdateIotSourcesBody } from '../../resources/types/iotSourcesTypes';

export const iotSourcesApi = createApi({
  reducerPath: 'iotSourcesApi',
  baseQuery,
  tagTypes: ['IotSources'],
  endpoints: builder => ({
    getIotSources: builder.query<IotSources, void>({
      query: () => '/iot_sources',
      providesTags: ['IotSources']
    }),

    updateIotSources: builder.mutation<IotSources, UpdateIotSourcesBody>({
      query: body => ({ url: '/iot_sources', method: 'PUT', body }),
      invalidatesTags: ['IotSources']
    })
  })
});

export const { useGetIotSourcesQuery, useUpdateIotSourcesMutation } = iotSourcesApi;
